import Button from "@mui/material/Button";
import "./SuccessModal.css";

const SuccessModal = ({ open, icon = "check_circle", title, message, buttonText = "OK", onClose }) => {
  if (!open) return null;

  return (
    <div className="success-modal-overlay">
      <div className="success-modal">
        <div className="success-icon">
          <span className="material-symbols-outlined">{icon}</span>
        </div>
        <h3>{title}</h3>
        <p>{message}</p>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onClose}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default SuccessModal;